@if (!showInactive) {
<div class="mct-flex mb-10 mct-justify-start mct-items-stretch">
  <a (click)="toggleInactiveView()"> {{ 'profiles.edit.billing.view-inactive' | translate | titlecase }} </a>
</div>
}
@if (!showInactive) {
<div [wl-busy-overlay]="loading" [busyCenter]="true">
  <div class="w-100 t-ar" style="padding: var(--p-tabs-tabpanel-padding)">
    <button pButton class="atlas-btn atlas-btn-secondary tall" (click)="addBilling()">
      <span class="pi pi-plus-circle mr-5" style="font-size: 18px"></span> {{ 'listing.add-new' | translate |
      titlecase }}
    </button>
  </div>
  <p-tabs lazy [value]="selectedIndex" class="mct-tabs-wrap">
    <p-tablist>
      @for (billing of value; track billing; let i = $index) {
      <p-tab [value]="i">
        {{ value[i].RevenueItem ? value[i].RevenueItem : ('profiles.edit.billing.new-billing' | translate | titlecase)
        }}
      </p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      @for (billing of value; track billing; let i = $index)
      {
      <p-tabpanel [value]="i">
        <ng-template #content>
          <div class="mct-flex mct-justify-end mct-items-stretch">
            <div class="flex items-center">
              <p-checkbox [binary]="true" [(ngModel)]="value[i].Inactive"></p-checkbox>
              <label>
                {{ 'profiles.edit.billing.inactive' | translate | titlecase }}
              </label>
            </div>
            <button class="btn btn-danger ml-27" [disabled]="value[i].IsARB" type="button" (click)="deleteBilling(i)"
              title="{{ 'common.delete' | translate | titlecase }}">
              {{ 'common.delete' | translate | titlecase }}
            </button>
          </div>
          <wl-profile-edit-billing [(ngModel)]="value[i]"></wl-profile-edit-billing>
        </ng-template>
      </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</div>
}
@if (showInactive) {
<div>
  <div class="mct-flex mb-10 mct-justify-start mct-items-stretch">
    <a (click)="toggleInactiveView()">
      <i class="pi pi-angle-left"></i> {{ 'profiles.edit.billing.back-to-active-billings' | translate | ucfirst }}
    </a>
  </div>
  <h3>{{ 'profiles.edit.billing.inactive-billings' | translate | titlecase }}</h3>
  <div *ngFor="let billing of value; index as i" class="mb-27" [wl-busy-overlay]="loading" [busyCenter]="true">
    <div class="mct-flex mct-justify-end mct-items-stretch">
      <div *ngIf="billing.IsARB && billing.Inactive" class="mr-10">
        <wl-notification-banner
          [translationKey]="'profiles.edit.billing.subscription-canceled-at-gateway'"></wl-notification-banner>
      </div>

      <div class="mr-5">
        {{ 'profiles.edit.billing.date-inactive' | translate | titlecase }}
      </div>
      <wl-date-selector class="mr-10" [disabled]="true" [(ngModel)]="value[i].DateInactive"></wl-date-selector>

      <p-checkbox [label]="'profiles.edit.billing.inactive' | translate | titlecase" [binary]="true"
        [disabled]="value[i].IsARB" [(ngModel)]="value[i].Inactive"></p-checkbox>
      <button class="btn btn-danger ml-27" [disabled]="value[i].IsARB" type="button" (click)="deleteBilling(i)"
        title="{{ 'common.delete' | translate | titlecase }}">
        {{ 'common.delete' | translate | titlecase }}
      </button>
    </div>
    <wl-profile-edit-billing [(ngModel)]="value[i]"></wl-profile-edit-billing>
    <hr />
  </div>
</div>
}
